// extracted by mini-css-extract-plugin
export var allFolderIconsRootText = "qWi7V";
export var chevronAnimation = "VGV9k";
export var chevronFontSize = "cXhO1";
export var chevronIcon = "YxSxn";
export var chevronPadding = "uFyEh";
export var chevronWithFolderIcon = "vPgzN";
export var collapse = "gl488";
export var compact = "if6B2";
export var customActionNode = "arc_i";
export var densityFontSizes = "u0T8k";
export var densityNodeHeights = "iDEcr";
export var disabledCursor = "Cw3Gl";
export var displayName = "gtcPn";
export var ellipsesHovered = "Nm7DL";
export var ellipsesIcon = "Gyuy5";
export var ellipsesOnHover = "qarSX";
export var focusStyling = "z6Kje";
export var folderIcons = "ppZg6";
export var folderPadding = "PTC00";
export var folderWithChevron = "cqDRB";
export var full = "LPIso";
export var hoverPadding = "aWRWM";
export var hoverTreatmentPresent = "Haof5";
export var icon = "jgnYx";
export var iconsNext = "MgbmD";
export var isBeingDragged = "nY2XK";
export var isDisabled = "NVk49";
export var leftNavAllFoldersPadding = "SuSxc";
export var leftNavIconExtraPadding = "Izlfm";
export var ltrStyles = "phvtt";
export var medium = "ORnNd";
export var overridenFont = "vHhj2";
export var regularNode = "C2IG3";
export var regularNodeChevronIcon = "psaT8";
export var rightCharm = "o03Ce";
export var rightCharmHover = "trZ2R";
export var rootFolderAlignment = "kbTWn";
export var rootHover = "MNZUM";
export var rootIcon = "SZ3Jt";
export var rootNode = "XVsEB";
export var rootNodeFont = "_Ptr3";
export var roundedCorners = "oTkSL";
export var rtlStyles = "GG7iR";
export var selected = "wk4Sg";
export var showAsHoverOnDroppedOver = "KxVc9";
export var showBorderOnDroppedOver = "guOtt";
export var withContextMenuOpen = "X0REb";